import { Controller } from "@hotwired/stimulus"

const NAV_HEIGHT = 56
const DAY_IN_MS = 24 * 60 * 60 * 1000

export default class extends Controller {
  static values = {
    storageKey: String,
    dismissForDays: Number
  }

  connect() {
    this.refreshOffset = this.refreshOffset.bind(this)

    if (this.dismissedRecently()) {
      this.hide()
      return
    }

    this.refreshOffset()
    window.addEventListener("resize", this.refreshOffset)
  }

  disconnect() {
    window.removeEventListener("resize", this.refreshOffset)
  }

  dismiss(event) {
    event.preventDefault()
    this.persistDismissal()
    this.hide()
  }

  dismissedRecently() {
    const dismissedAt = this.readDismissedAt()
    if (!dismissedAt) return false

    return Date.now() - dismissedAt < this.dismissForDays * DAY_IN_MS
  }

  hide() {
    window.removeEventListener("resize", this.refreshOffset)
    this.element.style.display = "none"
    document.documentElement.style.setProperty("--marketing-banner-height", "0px")
    document.documentElement.style.setProperty("--marketing-header-offset", `${NAV_HEIGHT}px`)
  }

  refreshOffset() {
    const bannerHeight = Math.ceil(this.element.getBoundingClientRect().height)
    document.documentElement.style.setProperty("--marketing-banner-height", `${bannerHeight}px`)
    document.documentElement.style.setProperty("--marketing-header-offset", `${bannerHeight + NAV_HEIGHT}px`)
  }

  persistDismissal() {
    try {
      localStorage.setItem(this.storageKey, String(Date.now()))
    } catch {
      return
    }
  }

  readDismissedAt() {
    try {
      const dismissedAt = localStorage.getItem(this.storageKey)
      if (!dismissedAt) return null

      const timestamp = Number.parseInt(dismissedAt, 10)
      return Number.isFinite(timestamp) ? timestamp : null
    } catch {
      return null
    }
  }

  get dismissForDays() {
    return this.hasDismissForDaysValue ? this.dismissForDaysValue : 7
  }

  get storageKey() {
    return this.hasStorageKeyValue ? this.storageKeyValue : "taphouse-marketing-app-banner-dismissed-at"
  }
}
